import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import {FormattedMessage} from "react-intl";
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

interface EmptyProps {
  icon?: string,
  message?: React.ReactNode,
  customContainerClassname?: string,
}

const Empty = ({
                 message = (
                   <FormattedMessage
                     id="no-files"
                     defaultMessage="No files"
                   />
                 ),
                 customContainerClassname
               }: EmptyProps) => {

  return (
    <div className={classnames(styles.emptyContainer, customContainerClassname)}>
      <img
        src={toAbsoluteUrl('/media/common/Empty.svg')}
        alt="empty"
        className={styles.emptyIcon}
      />
      <div className={styles.emptyMessage}>
        {message}
      </div>
    </div>
  )
};

export default Empty;
